export default "__VITE_ASSET__5Kg_8Nx3__"